import { gql } from '@urql/core';

export const mutationRemoveConnector = gql`
  mutation RemoveConnector($id: String!) {
    removeConnector(connectorId: $id) {
      id
    }
  }
`;
